import React from 'react';
import { Plus } from 'lucide-react'; // Keep this import

interface FloatingNewButtonProps {
  onClick: () => void;
}

export const FloatingNewButton: React.FC<FloatingNewButtonProps> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="fixed bottom-4 right-4 lg:bottom-6 lg:right-6 z-50 w-12 h-12 lg:w-16 lg:h-16 bg-modular-primary-gradient hover:shadow-modular-glow 
        text-white rounded-full shadow-2xl transition-all duration-300 
        transform hover:scale-110 active:scale-95 group
        flex items-center justify-center
        border-4 border-white dark:border-dark-surface
        hover:border-modular-accent-blue dark:hover:border-modular-accent-blue
        animate-modular-pulse"
      title="Create New Prompt"
    >
      <div className="absolute inset-0 bg-modular-secondary-gradient 
        opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-full" />
      <Plus className="h-6 w-6 lg:h-8 lg:w-8 relative z-10 group-hover:rotate-90 transition-transform duration-300" />
      
      {/* Subtle glow ring */}
      <div className="absolute inset-0 rounded-full bg-modular-frosted-indigo opacity-20 
        animate-ping group-hover:animate-none" />
    </button>
  );
};